<h4 mat-dialog-title>Modification propriétés champ email.</h4>
<mat-divider></mat-divider>
<form (ngSubmit)="onSubmit()" [formGroup]="editEmailInputForm" style="margin-top: 25px">
    <mat-dialog-content class="mat__typography">
        <div fxLayout="column" fxLayoutGap="15px">
            <div>
                <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                    <mat-label>{{placeholderTitle}}</mat-label>
                    <input formControlName="placeholder" matInput
                           matTooltip="{{placeholderText}}"
                           placeholder="{{placeholderText}}"
                           type="text" data-cy="input-email-placeholder">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                    <mat-label>Tooltip</mat-label>
                    <input formControlName="tooltip" matInput
                           matTooltip="{{tooltipText}}"
                           placeholder="{{tooltipText}}"
                           type="text" data-cy="input-email-tooltip">
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button (click)="onNoClick()"
                mat-raised-button
                color="accent"
                type="button"
                data-cy="button-email-input-dialog-cancel">
            Annuler
        </button>
        <button mat-raised-button
                cdkFocusInitial
                color="primary"
                type="submit"
                data-cy="button-email-input-dialog-save">
            Sauvegarder
        </button>
    </mat-dialog-actions>
</form>

